import { useEffect, useState } from 'react';

import { OptionsChangedV1, PdpPageEvents } from '@vp/pdp-events';

export const usePdpSelectedOptions = (): Record<string, string> => {
  const [selectedOptions, setSelectedOptions] = useState<Record<string, string>>({});

  useEffect(() => {
    const handleOptionsChanged = (optionsChanged: OptionsChangedV1) => {
      setSelectedOptions(optionsChanged.combination);
    };

    return PdpPageEvents.listenToOptionsChangedEventV1(handleOptionsChanged);
  }, []);

  return selectedOptions;
};
